/**
 * configuration
 */

export const jwordFontList=
	[
		{family:'Noto Sans',link:'https://fonts.googleapis.com/css?family=Noto+Sans&display=swap'},
		{family:'Noto Sans Light',link:'https://fonts.googleapis.com/css?family=Noto+Sans&display=swap'},
		{family:'Noto Serif',link:'https://fonts.googleapis.com/css?family=Noto+Serif&display=swap'},
		{family:'Noto Serif Light',link:'https://fonts.googleapis.com/css?family=Noto+Serif&display=swap'},
		{family:'Noto Sans Mono',link:'https://fonts.googleapis.com/css?family=Noto+Mono&display=swap'},
		{family:'Noto Sans Mono Light',link:'https://fonts.googleapis.com/css?family=Noto+Mono&display=swap'},
	];

export const jwordFontSizeList=
	[
		8,9,10,11,12,14,15,16,18,20,22,24,26,28,36,48,72
	];

export const jwordStyleList=
	[
		{name:'Normal',type:'P'},
		{name:'Heading1',type:'P'},
		{name:'Heading2',type:'P'},
		{name:'Heading3',type:'P'},
		{name:'Heading4',type:'P'},
		{name:'Heading5',type:'P'},
		{name:'Heading6',type:'P'},
		{name:'emp',type:'C'},
		{name:'strong',type:'C'},
		{name:'code',type:'C'}		
	];

export const jwordColorList=[];

var cv = [ '00', '56', 'aa', 'ff' ];
for(var r=0;r<4;r++)
	jwordColorList.push(cv[r]+cv[r]+cv[r]);

for (var r = 0; r < 4; r++)
	for (var g = 0; g < 4; g++)
		for (var b = 0; b < 4; b++)
		{
			if(r!=g || r!=b || b!=g)
			{
				let cl=cv[r]+cv[g]+cv[b];
				jwordColorList.push(cl);					
			}
		}		
jwordColorList.push('auto');

export const colorList = jwordColorList.map((c)=>c!='auto'?'#'+c:c);

export const jwordAlignmentOptions=['left','right','center','justified'];
export const jwordValignOptions=['top','center','bottom'];
export const jwordSpecialIndentOptions=['none','firstLine','hanging'];
export const jwordLineSpaceOptions=['single','double','exact','atLeast'];
export const jwordBorderThicknessOptions=[0.25,0.50,0.75,1.0,1.5,2.0,2.25,3.0,4.0,5.0,6.0];
export const jwordBorderAppRangeOptions=['para','cell','row','column','table'];
export const jwordUnitOptions=['physical','percent'];
export const jwordRowHeightOptions=['auto','atleast','exactly'];
export const jwordZoomOptions=[25,50,75,90,100,110,120,150,200,250,300];

